import React, { lazy } from 'react';
export function ResultsCollage() {
  const images = [{
    src: 'https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=300&h=300&fit=crop&crop=faces&q=80',
    alt: 'Beautiful dog portrait with warm lighting'
  }, {
    src: 'https://images.unsplash.com/photo-1530126483408-aa533e55bdb2?w=300&h=300&fit=crop&crop=faces&q=80',
    alt: 'Energetic dog action shot running outdoors'
  }, {
    src: 'https://images.unsplash.com/photo-1518717758536-85ae29035b6d?w=300&h=300&fit=crop&crop=faces&q=80',
    alt: 'Expressive dog showing personality in candid moment'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/1esMPNWPaSWeB2vvSKbKYo/ChatGPT_Image_Mar_20,_2026,_06_00_12_PM.png',
    alt: 'Breton español in the snow with warm golden light'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/59RPMESyxwcHuqwmaDkrZQ/ChatGPT_Image_Mar_20,_2026,_05_25_14_PM.png',
    alt: 'Golden retriever outdoors with warm golden hour lighting'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/9kkUzCCpDNywodHJQnRMmL/ChatGPT_Image_Mar_20,_2026,_05_53_11_PM.png',
    alt: 'Golden retriever on the beach at sunset'
  }];
  return <section className="bg-warm-deep py-16 md:py-20 px-4" data-id="element-232">
      <div className="max-w-4xl mx-auto" data-id="element-233">
        {/* Heading */}
        <p className="font-sans font-medium text-soft-gold uppercase tracking-wider text-xs md:text-sm text-center mb-8" data-id="element-234">
          Beautiful results from different kinds of dogs, moments, and styles
        </p>

        {/* Collage grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4 mb-8 max-w-3xl mx-auto" data-id="element-235">
          {images.map((img, index) => <div key={index} className="rounded-xl overflow-hidden shadow-md aspect-square" data-id="element-236">
              <img src={img.src} alt={img.alt} className="w-full h-full object-cover" loading="lazy" decoding="async" width={300} height={300} data-id="element-237" />
            </div>)}
        </div>

        {/* Text below */}
        <p className="font-sans text-lg md:text-xl text-gray-800 text-center max-w-2xl mx-auto leading-relaxed" data-id="element-238">
          From portraits to action shots to cozy everyday moments, this system
          helps you create{' '}
          <span className="font-semibold text-warm-hero" data-id="element-239">
            more photos you'll genuinely love.
          </span>
        </p>
      </div>
    </section>;
}